import * as _ from 'lodash';
import Config from '../config/config';
var TemplateService = /** @class */ (function () {
    function TemplateService(api) {
        this.api = api;
    }
    TemplateService.prototype.setDataToTemplateForm = function (updatedFormConfig, search) {
        var imageUrl = search.image_url ? Config.cdnDomain + search.image_url : null;
        _.set(updatedFormConfig, 'template.value', search.template);
        _.set(updatedFormConfig, 'template.touched', true);
        _.set(updatedFormConfig, 'template.valid', true);
        _.set(updatedFormConfig, 'name_bg.value', search.bg_name);
        _.set(updatedFormConfig, 'name_bg.touched', true);
        _.set(updatedFormConfig, 'name_bg.valid', true);
        _.set(updatedFormConfig, 'name_en.value', search.en_name);
        _.set(updatedFormConfig, 'name_en.touched', true);
        _.set(updatedFormConfig, 'name_en.valid', true);
        _.set(updatedFormConfig, 'button_value_bg.value', search.bg_button_name);
        _.set(updatedFormConfig, 'button_value_bg.touched', true);
        _.set(updatedFormConfig, 'button_value_bg.valid', true);
        _.set(updatedFormConfig, 'button_value_en.value', search.en_button_name);
        _.set(updatedFormConfig, 'button_value_en.touched', true);
        _.set(updatedFormConfig, 'button_value_en.valid', true);
        _.set(updatedFormConfig, 'link_value.value', search.link);
        _.set(updatedFormConfig, 'link_value.touched', true);
        _.set(updatedFormConfig, 'link_value.valid', true);
        _.set(updatedFormConfig, 'image.value', imageUrl);
        _.set(updatedFormConfig, 'image.touched', true);
        _.set(updatedFormConfig, 'image.valid', true);
    };
    return TemplateService;
}());
export default TemplateService;



//////////////////
// WEBPACK FOOTER
// ./src/services/template.service.ts
// module id = 489
// module chunks = 0